export default function(id) {
  this.observers.forEach(observer => {
    if (observer.id === id) observer.item.unsubscribe();
  });
  this.observers = this.observers.filter(d => d.id !== id);
}
